import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BoardAnalyticsDashboard from './BoardAnalyticsDashboard';
import './scss/AnalyticsPage.scss';
import { useSelector } from 'react-redux';

const AnalyticsPage = () => {
  const { boardId } = useParams();
  const navigate = useNavigate();
  const { boardAnalytics } = useSelector((state) => state.analytics);


  const handleBackToBoard = () => {
    navigate(`/b/${boardId}`);
  };

  return (
    <div className="analytics-page">
      <div className="analytics-navigation">

        <div className="page-title">
          <h1>Analytics - {boardAnalytics?.data?.boardTitle}</h1>
          <p>Insights and performance metrics for your board</p>
        </div>

        <button onClick={handleBackToBoard} className="back-button">
          <span className="material-symbols-outlined">arrow_back</span>
          Back to Board
        </button>
      </div>

      <div className="analytics-container">
        <BoardAnalyticsDashboard />
      </div>
    </div>
  );
};

export default AnalyticsPage;
